import React from 'react';
import ColorBlockList from '../color-block-list';
import {BLUES, NEUTRALS} from './constants';

const PRIMARY_BLUES = BLUES.filter((blue) => blue.type === 'primary');
const PRIMARY_NEUTRALS = NEUTRALS.filter((grey) => grey.type === 'primary');
const WHITE = [NEUTRALS[0]];
const BLACK = [NEUTRALS[NEUTRALS.length - 1]];

class PrimaryColors extends React.Component {
  render() {
    return (
      <div>
        <ColorBlockList groupName="Blue" colors={PRIMARY_BLUES} />
        <ColorBlockList groupName="Neutral" colors={PRIMARY_NEUTRALS} />
        <ColorBlockList groupName="White" colors={WHITE} />
        <ColorBlockList groupName="Black" colors={BLACK} />
      </div>
    );
  }
}

export default PrimaryColors;
